module.exports = __webpack_public_path__ + "img/icons-sjfx-teacher.fa3a7fda.png";